import React, { useContext } from "react";
import RoomContext from "../../context/RoomContext";
import { useDispatch, useSelector } from "react-redux";
import { makePeerConsumerSelector } from "../../helpers/Selectors";
import PropTypes from "prop-types";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import * as roomActions from "../../actions/roomActions";
import VideoView from "./Media/VideoView";
import HoveredView from "./Media/HoveredView";
import MediaBox from "./Media/MediaBox";
import PeerInfo from "./Media/PeerInfo";
import { toggleConsumerFullscreen } from "../../actions/roomActions";

const Peer = ({
  id,
  style,
  onFilmStrip = false,
  mini = false,
  excludeConsumer,
  makeFullScreenOnClick,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { roomClient } = useContext(RoomContext);
  const peer = useSelector((state) => state.peers[id]);
  const windowConsumer = useSelector((state) => state.room.windowConsumer);
  const room = useSelector((state) => state.room);
  const activeSpeaker = useSelector(
    (state) => id === state.room.activeSpeakerId
  );

  const getPeerConsumers = makePeerConsumerSelector();
  const { micConsumer, webcamConsumer, screenConsumer } = useSelector((state) =>
    getPeerConsumers(state, id)
  );

  const micEnabled =
    Boolean(micConsumer) &&
    !micConsumer.locallyPaused &&
    !micConsumer.remotelyPaused;

  const remoteMicEnabled = Boolean(micConsumer) && !micConsumer.remotelyPaused;

  const videoVisible =
    Boolean(webcamConsumer) &&
    !webcamConsumer.locallyPaused &&
    !webcamConsumer.remotelyPaused;

  const screenVisible =
    Boolean(screenConsumer) &&
    !screenConsumer.locallyPaused &&
    !screenConsumer.remotelyPaused;

  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  if (
    !room.webinar ||
    (room.webinar && (videoVisible || remoteMicEnabled || screenVisible))
  )
    return (
      <React.Fragment>
        {(room.webinar && screenConsumer && !webcamConsumer) ||
        (excludeConsumer && excludeConsumer === webcamConsumer) ? null : (
          <MediaBox activeSpeaker={activeSpeaker} style={style} mini={mini}>
            {!mini && (
              <HoveredView
                muteAudioButton={{
                  visible: true,
                  disabled: !micConsumer,
                  onClick: () => {
                    micEnabled
                      ? roomClient.modifyPeerConsumer(peer.id, "mic", true)
                      : roomClient.modifyPeerConsumer(peer.id, "mic", false);
                  },
                  micEnabled: micEnabled,
                }}
                /*              newWindowButton={{
                              visible: !smallScreen,
                              disabled: !videoVisible || windowConsumer === webcamConsumer.id,
                              onClick: () => {
                                if (webcamConsumer)
                                  dispatch(
                                    roomActions.toggleConsumerWindow(webcamConsumer.id)
                                  );
                              },
                            }}*/
                fullScreenButton={{
                  visible: true,
                  disabled: !videoVisible,
                  onClick: () => {
                    if (webcamConsumer)
                      dispatch(
                        roomActions.toggleConsumerFullscreen(webcamConsumer.id)
                      );
                  },
                }}
              />
            )}

            <PeerInfo
              peer={peer}
              isMe={false}
              isScreen={false}
              displayName={peer.displayName}
              showPeerInfo={true}
              audioScore={micConsumer ? micConsumer.score : null}
              videoScore={webcamConsumer ? webcamConsumer.score : null}
              micOff={!remoteMicEnabled}
              onFilmStrip={onFilmStrip}
              mini={mini}
              onClick={() => {
                if (makeFullScreenOnClick && webcamConsumer) {
                  dispatch(
                    roomActions.switchConsumerFullscreen(webcamConsumer.id)
                  );
                }
              }}
            />
            <VideoView
              peer={peer}
              displayName={peer.displayName}
              videoTrack={webcamConsumer && webcamConsumer.track}
              videoVisible={videoVisible}
              audioTrack={micConsumer && micConsumer.track}
            />
          </MediaBox>
        )}

        {screenConsumer && excludeConsumer !== screenConsumer && (
          <MediaBox style={style}>
            {!mini && (
              <HoveredView
                /*              newWindowButton={{
                              visible: !smallScreen,
                              disabled:
                                !screenVisible || windowConsumer === screenConsumer.id,
                              onClick: () => {
                                if (screenConsumer)
                                  dispatch(
                                    roomActions.toggleConsumerWindow(screenConsumer.id)
                                  );
                              },
                            }}*/
                fullScreenButton={{
                  visible: true,
                  disabled: !screenVisible,
                  onClick: () => {
                    if (screenConsumer)
                      dispatch(
                        roomActions.toggleConsumerFullscreen(screenConsumer.id)
                      );
                  },
                }}
              />
            )}

            <PeerInfo
              peer={peer}
              isMe={false}
              isScreen={true}
              displayName={peer.displayName}
              showPeerInfo={true}
              videoScore={screenConsumer ? screenConsumer.score : null}
              onFilmStrip={onFilmStrip}
              mini={mini}
              onClick={() => {
                if (makeFullScreenOnClick && screenConsumer) {
                  dispatch(
                    roomActions.switchConsumerFullscreen(screenConsumer.id)
                  );
                }
              }}
            />

            <VideoView
              peer={peer}
              videoContain
              displayName={peer.displayName}
              isScreen={true}
              videoTrack={screenConsumer && screenConsumer.track}
              videoVisible={screenVisible}
            />
          </MediaBox>
        )}
      </React.Fragment>
    );
  else return null;
};

Peer.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
  onFilmStrip: PropTypes.bool,
};

export default Peer;
